/* Grondyke · Bundle builder (PDP). Picks N products across three steps, shows the tier the
   stack has reached (tiers from section settings, prices from variant data attributes), and
   adds every picked item to the cart through GkCart (gk-main-product.js). The discount itself
   is Shopify's automatic discount at checkout; nothing here is a literal price. */
(function () {
  'use strict';

  function init(root) {
    var tiers = (root.getAttribute('data-tiers') || '').split(',').map(function (p) {
      var a = p.split(':'); return { n: Number(a[0]), pct: Number(a[1]) };
    }).filter(function (t) { return t.n > 0 && t.pct > 0; }).sort(function (a, b) { return a.n - b.n; });
    if (!tiers.length) return;
    var maxN = tiers[tiers.length - 1].n;
    var showLimit = Number(root.getAttribute('data-show-limit')) || 5;
    var str = {
      goal: root.getAttribute('data-goal-text') || '',
      done: root.getAttribute('data-goal-done') || '',
      total: root.getAttribute('data-total-label') || '',
      save: root.getAttribute('data-save-label') || '',
      next: root.getAttribute('data-next-label') || 'Next',
      add: root.getAttribute('data-add-label') || 'Add to cart',
      addBtn: root.getAttribute('data-add-btn') || '+ Add',
      removeBtn: root.getAttribute('data-remove-btn') || '− Remove',
      more: root.getAttribute('data-more-label') || 'Show all [n]',
      fewer: root.getAttribute('data-fewer-label') || 'Show fewer',
      one: root.getAttribute('data-items-one') || '1 item added',
      many: root.getAttribute('data-items-many') || '[n] items added'
    };
    var fmt = function (c) { return window.GkCart ? window.GkCart.formatMoney(c) : '$' + (c / 100).toFixed(2); };
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-gk-step]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gk-step-tab]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gk-card]'));
    var goalsEl = root.querySelector('[data-gk-goals]');
    var fillEl = root.querySelector('[data-gk-fill]');
    var goalEl = root.querySelector('[data-gk-goal]');
    var groupsEl = root.querySelector('[data-gk-groups]');
    var emptyEl = root.querySelector('[data-gk-empty]');
    var totalLabel = root.querySelector('[data-gk-total-label]');
    var netEl = root.querySelector('[data-gk-net]');
    var grossEl = root.querySelector('[data-gk-gross]');
    var saveEl = root.querySelector('[data-gk-save]');
    var cta = root.querySelector('[data-gk-cta]');
    var errorEl = root.querySelector('[data-gk-error]');
    var tpl = root.querySelector('[data-gk-tpl-item]');
    var step = 1, picked = [];

    // Goal markers on the progress bar.
    tiers.forEach(function (t) {
      var m = document.createElement('div');
      m.className = 'gk-bb__goalmark';
      m.style.left = (t.n / maxN * 100) + '%';
      m.setAttribute('data-n', t.n);
      m.innerHTML = '<span class="gk-bb__goaldot"></span><span class="gk-bb__goallabel">' + t.pct + '% off</span>';
      goalsEl.appendChild(m);
    });

    // Step 1 expander.
    steps.forEach(function (st) {
      var list = st.querySelectorAll('[data-gk-card]');
      var more = st.querySelector('[data-gk-more]');
      var btn = st.querySelector('[data-gk-more-btn]');
      if (!more || !btn || st.getAttribute('data-gk-step') !== '1' || list.length <= showLimit) return;
      var expanded = false;
      function apply() {
        for (var i = 0; i < list.length; i++) list[i].hidden = !expanded && i >= showLimit;
        btn.textContent = expanded ? str.fewer : str.more.replace('[n]', list.length);
      }
      more.hidden = false;
      btn.addEventListener('click', function () { expanded = !expanded; apply(); });
      apply();
    });

    function setStep(n) {
      step = Math.max(1, Math.min(steps.length, n));
      steps.forEach(function (st) { st.hidden = Number(st.getAttribute('data-gk-step')) !== step; });
      tabs.forEach(function (t) {
        var on = Number(t.getAttribute('data-gk-step-tab')) === step;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var prevs = root.querySelectorAll('[data-gk-step-prev]');
      for (var i = 0; i < prevs.length; i++) prevs[i].disabled = step === 1;
      var nexts = root.querySelectorAll('[data-gk-step-next]');
      for (var j = 0; j < nexts.length; j++) nexts[j].disabled = step === steps.length;
      cta.textContent = step === steps.length ? str.add : str.next;
    }

    function tierFor(count) {
      var t = null;
      tiers.forEach(function (x) { if (count >= x.n) t = x; });
      return t;
    }

    function render() {
      var count = picked.length;
      var tier = tierFor(count);
      var pct = tier ? tier.pct : 0;
      var gross = picked.reduce(function (s, p) { return s + p.price; }, 0);
      var net = Math.round(gross * (1 - pct / 100));
      // Progress and goal text
      fillEl.style.width = Math.min(100, count / maxN * 100) + '%';
      var marks = goalsEl.querySelectorAll('.gk-bb__goalmark');
      for (var i = 0; i < marks.length; i++) marks[i].classList.toggle('is-on', count >= Number(marks[i].getAttribute('data-n')));
      var next = null;
      tiers.forEach(function (x) { if (!next && count < x.n) next = x; });
      goalEl.textContent = next ? str.goal.replace('[n]', next.n - count).replace('[pct]', next.pct) : str.done;
      // Groups per step
      var old = groupsEl.querySelectorAll('.gk-bb__group');
      for (var o = 0; o < old.length; o++) old[o].remove();
      emptyEl.hidden = count > 0;
      steps.forEach(function (st) {
        var sn = Number(st.getAttribute('data-gk-step'));
        var items = picked.filter(function (p) { return p.step === sn; });
        if (!items.length) return;
        var g = document.createElement('div');
        g.className = 'gk-bb__group';
        var label = items.length === 1 ? str.one : str.many.replace('[n]', items.length);
        g.innerHTML = '<div class="gk-bb__group-head"><span class="gk-bb__group-title"></span><span class="gk-bb__group-count"></span></div><div class="gk-bb__group-items"></div>';
        g.querySelector('.gk-bb__group-title').textContent = st.getAttribute('data-step-label') || '';
        g.querySelector('.gk-bb__group-count').textContent = label;
        var wrap = g.querySelector('.gk-bb__group-items');
        items.forEach(function (p) {
          var node = tpl.content.firstElementChild.cloneNode(true);
          var img = node.querySelector('img');
          if (p.image) img.src = p.image; else img.remove();
          node.querySelector('.gk-bb__item-name').textContent = p.title;
          node.querySelector('.gk-bb__item-note').textContent = p.note;
          node.querySelector('.gk-bb__item-price').textContent = fmt(p.price);
          node.querySelector('.gk-bb__item-remove').addEventListener('click', function () { toggle(p.id, false); });
          wrap.appendChild(node);
        });
        groupsEl.insertBefore(g, emptyEl);
      });
      // Totals
      totalLabel.textContent = str.total.replace('[n]', count);
      netEl.textContent = fmt(net);
      grossEl.textContent = fmt(gross);
      grossEl.hidden = !pct;
      saveEl.textContent = pct ? str.save.replace('[pct]', pct).replace('[amount]', fmt(gross - net)) : '';
      cards.forEach(function (c) {
        var on = picked.some(function (p) { return p.id === c.getAttribute('data-variant-id'); });
        c.classList.toggle('is-picked', on);
        var b = c.querySelector('[data-gk-card-btn]');
        if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? str.removeBtn : str.addBtn; }
      });
      if (step === steps.length) cta.disabled = count === 0;
    }

    function toggle(id, force) {
      var idx = -1;
      picked.forEach(function (p, i) { if (p.id === id) idx = i; });
      var want = typeof force === 'boolean' ? force : idx < 0;
      if (want && idx < 0) {
        var c = null;
        cards.forEach(function (x) { if (x.getAttribute('data-variant-id') === id) c = x; });
        if (!c || c.getAttribute('data-available') !== 'true') return;
        picked.push({
          id: id, price: Number(c.getAttribute('data-price')) || 0, title: c.getAttribute('data-title') || '',
          note: c.getAttribute('data-note') || '', image: c.getAttribute('data-image') || '', step: Number(c.getAttribute('data-step'))
        });
      } else if (!want && idx > -1) {
        picked.splice(idx, 1);
      }
      render();
    }

    cards.forEach(function (c) {
      var b = c.querySelector('[data-gk-card-btn]');
      if (b) b.addEventListener('click', function () { toggle(c.getAttribute('data-variant-id')); });
    });
    tabs.forEach(function (t) { t.addEventListener('click', function () { setStep(Number(t.getAttribute('data-gk-step-tab'))); }); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-gk-step-prev]'), function (b) { b.addEventListener('click', function () { setStep(step - 1); }); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-gk-step-next]'), function (b) { b.addEventListener('click', function () { setStep(step + 1); }); });

    cta.addEventListener('click', function () {
      if (step < steps.length) { setStep(step + 1); return; }
      if (!picked.length) return;
      var items = picked.map(function (p) { return { id: Number(p.id), quantity: 1 }; });
      if (window.GkCart && window.GkCart.available()) {
        window.GkCart.add(items, [cta], errorEl).then(function (ok) { if (ok) { picked = []; render(); } });
      } else {
        // No Eurus stores: post the items with a plain form to the cart page.
        var f = document.createElement('form');
        f.method = 'post'; f.action = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add';
        items.forEach(function (it, i) {
          var a = document.createElement('input'); a.type = 'hidden'; a.name = 'items[' + i + '][id]'; a.value = it.id; f.appendChild(a);
          var b = document.createElement('input'); b.type = 'hidden'; b.name = 'items[' + i + '][quantity]'; b.value = it.quantity; f.appendChild(b);
        });
        document.body.appendChild(f); f.submit();
      }
    });

    setStep(1);
    // The product being viewed starts in the stack, which is how every mockup ships this section.
    cards.forEach(function (c) {
      if (c.getAttribute('data-gk-preselect') === 'true') toggle(c.getAttribute('data-variant-id'), true);
    });
    render();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gk-bundle]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].hasAttribute('data-gk-ready')) { roots[i].setAttribute('data-gk-ready', ''); init(roots[i]); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
